<div class="bf-divider">
  <span *ngIf="text">
    {{ text }}
  </span>
</div>
